import React, { FC } from 'react';
import styled from 'styled-components';
import { Table, TH } from '../../../components/table/table';
import { IProductAvailability } from '../../../graphql/types';
import { White } from '../../../styles/colours';
import { ProductTransactionDetails } from './table-body';

const StyledProductAvailabilityTable = styled(Table)`
  background-color: ${White};
  border-radius: 0.25rem;
`;

interface IProductAvailabilityTableProps {
  productAvailability: IProductAvailability;
}

const ProductAvailabilityTable: FC<IProductAvailabilityTableProps> = ({
  productAvailability,
}) => (
  <StyledProductAvailabilityTable>
    <thead>
      <tr>
        <TH align="left">Date</TH>
        <TH align="left">MRP Code</TH>
        <TH align="left">Element data</TH>
        <TH align="left">Customer ID</TH>
        <TH align="left">Receipt Req</TH>
        <TH align="left">Available</TH>
      </tr>
    </thead>
    <ProductTransactionDetails transaction={productAvailability.transactions} />
  </StyledProductAvailabilityTable>
);

export { ProductAvailabilityTable };
